import { colmarLogoBase64 } from 'assets/colmarLogoBase64';

import { SkeletonBlock } from 'components/Skeleton';

import * as S from '../StyleRow/StyleRow.styles';
import * as Sk from './StyleRowSkeleton.styles';

type StyleRowSkeletonProps = {
  /** Colour lines to draw, so the skeleton is about as tall as the row it stands for. */
  colours?: number;
  /**
   * Shimmer animation (default on). Off for the placeholders of not-yet-rendered
   * rows: a large order has hundreds of them off screen, and thousands of
   * infinite animations keep the tab busy even when idle.
   */
  animated?: boolean;
};

/**
 * Loading placeholder of one style row of the order grid — same layout as
 * StyleRow and the same shimmer as the catalogue's ListItemSkeleton. Kept to a
 * handful of elements: it also stands in for every not-yet-rendered row of a
 * large order.
 */
export function StyleRowSkeleton({
  colours = 3,
  animated = true,
}: StyleRowSkeletonProps): React.ReactElement {
  return (
    <S.Section aria-hidden="true" data-testid="style-row-skeleton">
      <S.ImageCell>
        <Sk.Logo src={colmarLogoBase64} alt="" />
      </S.ImageCell>
      <S.Body>
        <S.HeaderRow>
          <S.InfoCell>
            <SkeletonBlock
              $animated={animated}
              width="60%"
              height="2rem"
              margin="0 0 0.6rem"
            />
            <SkeletonBlock $animated={animated} width="40%" height="1.4rem" />
          </S.InfoCell>
          <SkeletonBlock $animated={animated} height="3.2rem" />
          <SkeletonBlock $animated={animated} height="3.2rem" />
          <SkeletonBlock $animated={animated} height="3.2rem" />
        </S.HeaderRow>
        {Array.from({ length: colours }, (_, i) => (
          <Sk.ColourLine key={i} data-testid="style-row-skeleton-colour">
            <SkeletonBlock $animated={animated} height="4.4rem" />
          </Sk.ColourLine>
        ))}
      </S.Body>
    </S.Section>
  );
}
